module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img66.b0409e09.jpg";